document.documentElement.classList.remove('no-js');

(function(){
  function initHeader(root){
    root=root||document;
    var header=root.querySelector ? root.querySelector('.site-header') : null;
    if(!header && root.matches && root.matches('.site-header')) header=root;
    if(!header) header=document.querySelector('.site-header');
    if(!header || header.getAttribute('data-fnp-header-init')==='true') return;

    var toggle=header.querySelector('[data-menu-toggle]');
    var nav=header.querySelector('[data-mobile-nav]');
    if(!toggle||!nav)return;
    header.setAttribute('data-fnp-header-init','true');
    toggle.setAttribute('aria-expanded','false');

    toggle.addEventListener('click',function(){
      var open=nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded',open?'true':'false');
    });
    nav.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click',function(){
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded','false');
      });
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&nav.classList.contains('is-open')){
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded','false');
        toggle.focus();
      }
    });
  }

  function initStickyPurchase(root){
    root=root||document;
    var sticky=document.querySelector('.f5p-stick');
    var purchase=document.querySelector('.fnp-product .product-info');
    if(!sticky||!purchase||!('IntersectionObserver' in window))return;
    if(sticky.getAttribute('data-fnp-observer-init')==='true')return;
    sticky.setAttribute('data-fnp-observer-init','true');
    var observer=new IntersectionObserver(function(entries){
      var entry=entries[0];
      sticky.classList.toggle('fnp-sticky-hidden',!!entry&&entry.isIntersecting);
    },{threshold:.08});
    observer.observe(purchase);
  }

  function initAll(root){
    initHeader(root);
    initStickyPurchase(root);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initAll(document);});
  }else{
    initAll(document);
  }

  document.addEventListener('shopify:section:load',function(event){
    initAll(event.target||document);
  });
})();
